export const DONOR_SUBMIT = 'DONOR_SUBMIT';
export const DONOR_SUBMIT_SUCCESS = 'DONOR_SUBMIT_SUCCESS';
export const DONOR_SUBMIT_ERROR = 'DONOR_SUBMIT_ERROR';

export const DONOR_UPDATE = 'DONOR_UPDATE';
export const DONOR_UPDATE_SUCCESS = 'DONOR_UPDATE_SUCCESS';
export const DONOR_UPDATE_ERROR = 'DONOR_UPDATE_ERROR';

export const DONOR_SELFSERVICE = 'DONOR_SELFSERVICE';
export const DONOR_SELFSERVICE_SUCCESS = 'DONOR_SELFSERVICE_SUCCESS';
export const DONOR_SELFSERVICE_ERROR = 'DONOR_SELFSERVICE_ERROR';

export const NOTIFY_DONORS = 'NOTIFY_DONORS';
export const NOTIFY_DONORS_SUCCESS = 'NOTIFY_DONORS_SUCCESS';
export const NOTIFY_DONORS_ERROR = 'NOTIFY_DONORS_ERROR';

export const ALL_DONORS_FETCH = 'ALL_DONORS_FETCH';
export const ALL_DONORS_FETCH_SUCCESS = 'ALL_DONORS_FETCH_SUCCESS';
export const ALL_DONORS_FETCH_ERROR = 'ALL_DONORS_FETCH_ERROR';

export const DONOR_FETCHBYPHONE = 'DONOR_FETCHBYPHONE';
export const DONOR_FETCHBYPHONE_SUCCESS = 'DONOR_FETCHBYPHONE_SUCCESS';
export const DONOR_FETCHBYPHONE_ERROR = 'DONOR_FETCHBYPHONE_ERROR';

export const ADD_VOLUNTEER_DONOR = 'ADD_VOLUNTEER_DONOR';
export const ADD_VOLUNTEER_DONOR_SUCCESS = 'ADD_VOLUNTEER_DONOR_SUCCESS';
export const ADD_VOLUNTEER_DONOR_ERROR = 'ADD_VOLUNTEER_DONOR_ERROR';

export const DELETE_VOLUNTEER_DONOR = 'DELETE_VOLUNTEER_DONOR';
export const DELETE_VOLUNTEER_DONOR_SUCCESS = 'DELETE_VOLUNTEER_DONOR_SUCCESS';
export const DELETE_VOLUNTEER_DONOR_ERROR = 'DELETE_VOLUNTEER_DONOR_ERROR';

export const ADD_ACTUAL_DONOR = 'ADD_ACTUAL_DONOR';
export const ADD_ACTUAL_DONOR_SUCCESS = 'ADD_ACTUAL_DONOR_SUCCESS';
export const ADD_ACTUAL_DONOR_ERROR = 'ADD_ACTUAL_DONOR_ERROR';

export const PATIENT_SUBMIT = 'PATIENT_SUBMIT';
export const PATIENT_SUBMIT_SUCCESS = 'PATIENT_SUBMIT_SUCCESS';
export const PATIENT_SUBMIT_ERROR = 'PATIENT_SUBMIT_ERROR';

export const PATIENT_UPDATE = 'PATIENT_UPDATE';
export const PATIENT_UPDATE_SUCCESS = 'PATIENT_UPDATE_SUCCESS';
export const PATIENT_UPDATE_ERROR = 'PATIENT_UPDATE_ERROR';

export const ALL_PATIENT_FETCH = 'ALL_PATIENT_FETCH';
export const ALL_PATIENT_FETCH_SUCCESS = 'ALL_PATIENT_FETCH_SUCCESS';
export const ALL_PATIENT_FETCH_ERROR = 'ALL_PATIENT_FETCH_ERROR';

export const PATIENT_FETCH = 'PATIENT_FETCH';
export const PATIENT_FETCH_SUCCESS = 'PATIENT_FETCH_SUCCESS';
export const PATIENT_FETCH_ERROR = 'PATIENT_FETCH_ERROR';

export const FETCH_BY_PATIENT_NAME = 'FETCH_BY_PATIENT_NAME';
export const FETCH_BY_PATIENT_NAME_SUCCESS = 'FETCH_BY_PATIENT_NAME_SUCCESS';
export const FETCH_BY_PATIENT_NAME_ERROR = 'FETCH_BY_PATIENT_NAME_ERROR';

export const FETCH_BY_PATIENT_PHONE = 'FETCH_BY_PATIENT_PHONE';
export const FETCH_BY_PATIENT_PHONE_SUCCESS = 'FETCH_BY_PATIENT_PHONE_SUCCESS';
export const FETCH_BY_PATIENT_PHONE_ERROR = 'FETCH_BY_PATIENT_PHONE_ERROR';

export const FETCH_BY_ATTENDER_NAME = 'FETCH_BY_ATTENDER_NAME';
export const FETCH_BY_ATTENDER_NAME_SUCCESS = 'FETCH_BY_ATTENDER_NAME_SUCCESS';
export const FETCH_BY_ATTENDER_NAME_ERROR = 'FETCH_BY_ATTENDER_NAME_ERROR';

export const PATIENT_VERIFY = 'PATIENT_VERIFY';
export const PATIENT_VERIFY_SUCCESS = 'PATIENT_VERIFY_SUCCESS';
export const PATIENT_VERIFY_ERROR = 'PATIENT_VERIFY_ERROR';

export const MATCH_DONORS = 'MATCH_DONORS';
export const MATCH_DONORS_SUCCESS = 'MATCH_DONORS_SUCCESS';
export const MATCH_DONORS_ERROR = 'MATCH_DONORS_ERROR';

export const MATCH_DONOR_PHONE = 'MATCH_DONOR_PHONE';
export const MATCH_DONOR_PHONE_SUCCESS = 'MATCH_DONOR_PHONE_SUCCESS';
export const MATCH_DONOR_PHONE_ERROR = 'MATCH_DONOR_PHONE_ERROR';

export const SAVE_MATCHING_DONOR = 'SAVE_MATCHING_DONOR';
export const SAVE_MATCHING_DONOR_SUCCESS = 'SAVE_MATCHING_DONOR_SUCCESS';
export const SAVE_MATCHING_DONOR_ERROR = 'SAVE_MATCHING_DONOR_ERROR';

export const IMPORT_DONORS = 'IMPORT_DONORS';
export const IMPORT_DONORS_SUCCESS = 'IMPORT_DONORS_SUCCESS';
export const IMPORT_DONORS_ERROR = 'IMPORT_DONORS_ERROR';

export const SEND_OTP_DONOR = 'SEND_OTP_DONOR';
export const SEND_OTP_DONOR_SUCCESS = 'SEND_OTP_DONOR_SUCCESS';
export const SEND_OTP_DONOR_ERROR = 'SEND_OTP_DONOR_ERROR';

export const LOCALITY_FETCH = 'LOCALITY_FETCH';
export const LOCALITY_FETCH_SUCCESS = 'LOCALITY_FETCH_SUCCESS';
export const LOCALITY_FETCH_ERROR = 'LOCALITY_FETCH_ERROR';

export const DISTRICT_FETCH = 'DISTRICT_FETCH';
export const DISTRICT_FETCH_SUCCESS = 'DISTRICT_FETCH_SUCCESS';
export const DISTRICT_FETCH_ERROR = 'DISTRICT_FETCH_ERROR';

export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';

export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';

export const FETCH_ALL_ADMIN = 'FETCH_ALL_ADMIN';
export const FETCH_ALL_ADMIN_SUCCESS = 'FETCH_ALL_ADMIN_SUCCESS';
export const FETCH_ALL_ADMIN_ERROR = 'FETCH_ALL_ADMIN_ERROR';

export const DEREGISTER_ADMIN = 'DEREGISTER_ADMIN';
export const DEREGISTER_ADMIN_SUCCESS = 'DEREGISTER_ADMIN_SUCCESS';
export const DEREGISTER_ADMIN_ERROR = 'DEREGISTER_ADMIN_ERROR';

export const SAVE_SECONDARY_DISTRICTS = 'SAVE_SECONDARY_DISTRICTS';
export const SAVE_SECONDARY_DISTRICTS_SUCCESS = 'SAVE_SECONDARY_DISTRICTS_SUCCESS';
export const SAVE_SECONDARY_DISTRICTS_ERROR = 'SAVE_SECONDARY_DISTRICTS_ERROR';

export const PLACES_CHANGE = 'PLACES_CHANGE';